import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

// Renamed component to match its actual purpose
const SupportCard = ({ 
  id, 
  description = 'No description', 
  type = 'N/A',
  date = '',
  time = '',
  ticket_id = 'N/A',
  status = 'Pending'
}) => {
  const navigate = useNavigate();

  const handleCardClick = (e) => {
    if (e.target.closest('button')) return;
    navigate(`/dashboard/settings/support/${id}`);
  };

  // Determine background color based on status
  const getStatusColorClasses = () => {
    switch(status.toLowerCase()) {
      case 'closed':
        return { bg: 'bg-danger', text: 'text-danger' };
      case 'resolved':
        return { bg: 'bg-success', text: 'text-success' };
      case 'in progress':
        return { bg: 'bg-warning', text: 'text-warning' };
      case 'open':
      case 'pending':
      default:
        return { bg: 'bg-primary', text: 'text-primary' };
    }
  };

  const statusColors = getStatusColorClasses();

  return (
    <div 
      className="flex items-center gap-4 p-5 w-full rounded-lg bg-[var(--header-bg)] cursor-pointer"
      onClick={handleCardClick}
    >
      {/* Ticket Info */}
      <div className="flex flex-col text-left min-w-0">
        <h3 className="text-bold font-semibold truncate">{description}</h3>
        <p className="text-small font-normal truncate">{ticket_id}</p>
        <span className="text-small whitespace-nowrap font-medium">{type}</span>
      </div>

      {/* Date/Time and Status */}
      <div className="flex flex-col ml-auto">
        <div className="flex items-center gap-1">
          <span className="text-small whitespace-nowrap font-medium">
            {date} {time && `- ${time}`}
          </span>
        </div> 
        <div className="flex items-center justify-end gap-1">
          <div className={`w-2 h-2 rounded-full ${statusColors.bg}`}></div>
          <span className={`text-small-xs font-medium ${statusColors.text}`}>{status}</span>
        </div>
      </div>
    </div>
  );
};

SupportCard.propTypes = {
  id: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  date: PropTypes.string,
  time: PropTypes.string,
  ticket_id: PropTypes.string,
  status: PropTypes.string,
};

export default SupportCard;